import { useEffect, useState } from "react";

import {
  FaHandshake,
  FaGlobe,
  FaBookOpen,
  FaLeaf
} from "react-icons/fa";

import styles from "./ValuesSection.module.css";


const values = [
  {
    title:"Respekt",
    text:"Wir begegnen einander mit Wertschätzung und schaffen ein vertrauensvolles Miteinander.",
    icon:<FaHandshake />,
    color:"green"
  },
  {
    title:"Vielfalt",
    text:"Wir leben kulturelle Vielfalt und sehen sie als Bereicherung für unsere Schulgemeinschaft.",
    icon:<FaGlobe />,
    color:"blue"
  },
  {
    title:"Bildung",
    text:"Wir fördern individuelle Talente und begleiten junge Menschen auf ihrem Lernweg.",
    icon:<FaBookOpen />,
    color:"yellow"
  },
  {
    title:"Verantwortung",
    text:"Wir übernehmen Verantwortung für uns selbst, für andere und für unsere Welt.",
    icon:<FaLeaf />,
    color:"purple"
  }
];


export default function ValuesSection(){

const [active,setActive] = useState(0);

const [startX,setStartX] = useState(null);



useEffect(()=>{

const timer = setInterval(()=>{

setActive(prev =>
 prev === values.length - 1 ? 0 : prev + 1
);

},3000);


return ()=>clearInterval(timer);

},[]);



const nextSlide = ()=>{

setActive(prev =>
 prev === values.length - 1 ? 0 : prev + 1
);

};


const prevSlide = ()=>{

setActive(prev =>
 prev === 0 ? values.length - 1 : prev - 1
);

};



const handleTouchStart = (e)=>{

setStartX(e.touches[0].clientX);

};



const handleTouchEnd = (e)=>{

if(!startX) return;


const endX = e.changedTouches[0].clientX;

const diff = startX - endX;



if(diff > 50){

nextSlide();

}


if(diff < -50){

prevSlide();

}


setStartX(null);

};




return (

<section className={styles.section}>


<h1>Wofür wir stehen</h1>



<div
className={styles.mobileSlider}
onTouchStart={handleTouchStart}
onTouchEnd={handleTouchEnd}
>


<div
className={`${styles.card} ${styles[values[active].color]}`}
>


<div className={styles.icon}>
{values[active].icon}
</div>


<h3>
{values[active].title}
</h3>


<p>
{values[active].text}
</p>


</div>


</div>




<div className={styles.dots}>

{values.map((_,index)=>(

<button
key={index}
className={
index === active
? styles.activeDot
: ""
}
onClick={()=>setActive(index)}
></button>

))}

</div>




<div className={styles.desktopCards}>

{values.map((item,index)=>(

<div
key={index}
className={`${styles.card} ${styles[item.color]}`}
>

<div className={styles.icon}>
{item.icon}
</div>


<h3>
{item.title}
</h3>


<p>
{item.text}
</p>


</div>

))}

</div>



</section>

)

}